export const widgetIds = {
    "main": {
        "push":
            {
                "prevPc": "28691",
                "prevMob": "28691",
                "fullPc": "28691",
                "fullMob": "28691"
            },
        "aa2":
            {
                "prevPc": "14885",
                "prevMob": "14885",
                "fullPc": "14885",
                "fullMob": "14885"
            },
        "lookAlso":
            {
                "prevPc": "14886",
                "prevMob": "14886",
                "fullPc": "14886",
                "fullMob": "14886"
            },
        "feed":
            {
                "prevPc": "14849",
                "prevMob": "14849",
                "fullPc": "14849",
                "fullMob": "14849"
            },
        "sideBar":
            {
                "prevPc": "14890",
                "fullPc": "14890",
            },
        "empty": {
            "prevPc": "18083",
            "prevMob": "18083",
            "fullPc": "18083",
            "fullMob": "18083"
        },
        "backClick": "28705",
        "popup": "28706",
        "refresh": "lp",
    },
    "14556": {
        "sideBar": {
            "prevPc": "31892",
            "fullPc": "31893",
            "isSticky": true,
        },
        "aa2": {
            "prevPc": "31894",
            "prevMob": "31895",
            "fullPc": "31896",
            "fullMob": "31897"
        },
        "lookAlso": {
            "prevPc": "31898",
            "prevMob": "31899",
            "fullPc": "31900",
            "fullMob": "31901"
        },
        "feed": {
            "prevPc": "31903",
            "prevMob": "31904",
            "fullPc": "31905",
            "fullMob": "31906"
        },
        "push": {
            "prevPc": "31907",
            "prevMob": "31908",
            "fullPc": "31909",
            "fullMob": "31910"
        },
        "backClick": "31911",
        "popup": "31913",
        "refresh": "lp2001_14556",
    },
    "BY": {
        "sideBar": {
            "prevPc": "31941",
            "fullPc": "31938",
            "isSticky": true,
        },
        "aa2": {
            "prevPc": "31945",
            "prevMob": "31944",
            "fullPc": "31943",
            "fullMob": "31942"
        },
        "lookAlso": {
            "prevPc": "31967",
            "prevMob": "31964",
            "fullPc": "31959",
            "fullMob": "31956"
        },
        "feed": {
            "prevPc": "31979",
            "prevMob": "31976",
            "fullPc": "31973",
            "fullMob": "31970"
        },
        "push": {
            "prevPc": "31992",
            "prevMob": "31989",
            "fullPc": "31986",
            "fullMob": "31983"
        },
        "backClick": "31995",
        "popup": "31998",
        "refresh": "lp2001_BY",
    },
    "KZ": {
        "sideBar": {
            "prevPc": "31940",
            "fullPc": "31937",
            "isSticky": true,
        },
        "aa2": {
            "prevPc": "31947",
            "prevMob": "31949",
            "fullPc": "31951",
            "fullMob": "31953"
        },
        "lookAlso": {
            "prevPc": "31966",
            "prevMob": "31963",
            "fullPc": "31958",
            "fullMob": "31955"
        },
        "feed": {
            "prevPc": "31978",
            "prevMob": "31975",
            "fullPc": "31972",
            "fullMob": "31969"
        },
        "push": {
            "prevPc": "31991",
            "prevMob": "31988",
            "fullPc": "31985",
            "fullMob": "31982"
        },
        "backClick": "31994",
        "popup": "31997",
        "refresh": "lp2001_KZ",
    },
    "EXT": {
        "sideBar": {
            "prevPc": "31939",
            "fullPc": "31936",
            "isSticky": true,
        },
        "aa2": {
            "prevPc": "31946",
            "prevMob": "31948",
            "fullPc": "31950",
            "fullMob": "31952"
        },
        "lookAlso": {
            "prevPc": "31965",
            "prevMob": "31962",
            "fullPc": "31957",
            "fullMob": "31954"
        },
        "feed": {
            "prevPc": "31977",
            "prevMob": "31974",
            "fullPc": "31971",
            "fullMob": "31968"
        },
        "push": {
            "prevPc": "31990",
            "prevMob": "31987",
            "fullPc": "31984",
            "fullMob": "31981"
        },
        "backClick": "31993",
        "popup": "31996",
        "refresh": "lp2001_EXT",
    }
}
